import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Nav from "@/components/Nav";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "checking", payment_status: "pending", tries: 0 });

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    let tries = 0;
    const tick = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setState({ ...data, tries });
        if (data.payment_status === "paid") {
          refresh();
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) return;
        if (tries >= 45) return;
      } catch (e) {
        // ignore transient
      }
      if (!cancelled) setTimeout(tick, 2000);
    };
    tick();
    return () => {
      cancelled = true;
    };
  }, [sessionId, refresh]);

  const isPaid = state.payment_status === "paid";
  const isFailed = ["failed", "expired"].includes(state.payment_status);

  return (
    <div>
      <Nav />
      <div className="mx-auto max-w-[900px] px-6 py-24">
        <div className="border border-[#222] bg-[#0A0A0B] p-12 text-center" data-testid="payment-success-card">
          {isPaid ? (
            <>
              <CheckCircle2 size={56} className="mx-auto text-[#00F0FF]" />
              <h1 className="mt-6 font-display text-6xl">You are Pro.</h1>
              <p className="mt-3 text-[#c8c8c8]">
                Payment confirmed. Time to make some noise.
              </p>
              <Link to="/studio" className="btn-brutal mt-8 inline-flex" data-testid="success-cta-studio">
                Open Studio
              </Link>
            </>
          ) : isFailed ? (
            <>
              <XCircle size={56} className="mx-auto text-[#FF003C]" />
              <h1 className="mt-6 font-display text-5xl">Payment {state.payment_status}</h1>
              <Link to="/pricing" className="btn-brutal mt-6 inline-flex">
                Try Again
              </Link>
            </>
          ) : (
            <>
              <Loader2 size={48} className="mx-auto animate-spin text-[#FFE800]" />
              <h1 className="mt-6 font-display text-5xl">Confirming Payment…</h1>
              <p className="mt-3 text-sm text-[#c8c8c8]">
                Waiting for confirmation of your subscription. This usually takes a few seconds.
              </p>
              <p className="mt-3 font-mono text-xs uppercase tracking-widest text-[#808080]">
                Ref: {sessionId?.slice(0, 14)}… · attempt {state.tries}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
